/* eslint-disable import/prefer-default-export */
import tw from 'twin.macro';

export const styles = {
  label: ({ disabled }) => [
    tw`flex items-center cursor-pointer break-words min-w-0`,
    `padding-top: 0.3125rem; padding-bottom: 0.3125rem;`,
    disabled && tw`cursor`
  ],
  radioButton: ({ disabled }) => [
    tw`cursor-pointer`,
    disabled && [
      tw`border-silver-lighten-15 bg-silver-lighten-15 cursor checked:(border-silver-lighten-15 bg-silver-lighten-15 cursor)`,
      `background-blend-mode: luminosity;`
    ]
  ]
};
